import { styled } from 'styled-components'

const TextEllipsisContainer = styled(Flex)`
  flex: 1;
  width: 0px;
  min-width: 0px;
`

export default TextEllipsisContainer
